import { Book, Home, Upload, Play, Share2, ListMusic, Mic, User, Keyboard, Sparkles, Code } from "lucide-react"
import { paths } from "@src/utils/paths"
import { LucideIcon } from "lucide-react"

export interface NavItem {
  name: string
  href: string
  icon: LucideIcon
}

export interface NavSection {
  title: string
  items: NavItem[]
}

export const navigation: NavSection[] = [
  {
    title: "Getting started",
    items: [
      { name: "Introduction", href: paths.docs.index, icon: Book },
      { name: "Creating an account", href: paths.docs.gettingStarted, icon: Home },
      { name: "Uploading tracks", href: paths.docs.uploadingTracks, icon: Upload },
    ]
  },
  {
    title: "Using the player",
    items: [
      { name: "Player controls", href: paths.docs.player, icon: Play },
      { name: "Keyboard shortcuts", href: paths.docs.keyboardShortcuts, icon: Keyboard },
    ]
  },
  {
    title: "Organizing your music",
    items: [
      { name: "Playlists", href: paths.docs.playlists, icon: ListMusic },
    ]
  },
  {
    title: "Collaboration",
    items: [
      { name: "Sharing", href: paths.docs.sharing, icon: Share2 },
      { name: "Embedding", href: paths.docs.embedding, icon: Code },
    ]
  },
  {
    title: "Advanced features",
    items: [
      { name: "Recording", href: paths.docs.recording, icon: Mic },
    ]
  },
  {
    title: "Your account",
    items: [
      { name: "Account settings", href: paths.docs.account, icon: User },
    ]
  },
  {
    title: "Updates",
    items: [
      { name: "What's new?", href: paths.changelog, icon: Sparkles },
    ]
  },
]
